// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { makeAutoObservable, runInAction } from "mobx";

import { RootStore } from "../RootStore";
import { resetOnTenantOrUserChange } from "../RootStore/resetOnTenantOrUserChange";
import { JusticeInvolvedPersonsStore } from "./JusticeInvolvedPersonsStore";
import { OpportunityConfigurationStore } from "./Opportunity/OpportunityConfigurations/OpportunityConfigurationStore";

/**
 * Modular version of a store for Workflows, which contains references to stores for more
 * fine-grained types of data in Workflows.
 */
export class WorkflowsRootStore {
  justiceInvolvedPersonsStore?: JusticeInvolvedPersonsStore;
  opportunityConfigurationStore: OpportunityConfigurationStore;

  constructor(public rootStore: RootStore) {
    this.opportunityConfigurationStore = new OpportunityConfigurationStore(
      rootStore,
    );

    makeAutoObservable(this);

    resetOnTenantOrUserChange(this.rootStore, () =>
      runInAction(() => this.reset()),
    );
  }

  private reset() {
    this.justiceInvolvedPersonsStore = undefined;
    this.opportunityConfigurationStore.reset();
  }

  /**
   * Creates this.justiceInvolvedPersonsStore for the current tenant, if it does not already exist.
   */
  populateJusticeInvolvedPersonsStore(): void {
    if (this.justiceInvolvedPersonsStore) return;

    this.justiceInvolvedPersonsStore = new JusticeInvolvedPersonsStore(
      this.rootStore.firestoreStore,
    );
  }
}
